import React from 'react';
import { BadgeCheck } from 'lucide-react';

export const VerifiedBadge = ({ show, compact = false, testid = 'verified-badge' }) => {
  if (!show) return null;
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full bg-green-500/15 text-green-600 dark:text-green-400 border border-green-500/30 px-1.5 py-0.5 text-[11px] font-semibold"
      title="Profissional verificado"
      aria-label="Profissional verificado"
      data-testid={testid}
    >
      <BadgeCheck className="h-3.5 w-3.5" />
      {!compact && 'Profissional verificado'}
    </span>
  );
};
